import { useEffect, useState } from "react";
import { useQuery } from "react-query";
import { convertCurrency } from "../../modules/transactions/services/transactionApi";

const useConvertedCurrency = (amount, fromCurrency, toCurrency) => {
  const [convertedTurnOver, setConvertedTurnOver] = useState(0);

  const { data, isLoading, isError, error } = useQuery(
    ["convert", amount, fromCurrency, toCurrency],
    () => convertCurrency(amount, fromCurrency, toCurrency),
    {
      enabled: !!amount && !!fromCurrency && !!toCurrency && fromCurrency !== toCurrency,
    }
  );

  useEffect(() => {
    if (data) {
      setConvertedTurnOver(data);
    } else if (fromCurrency === toCurrency) {
      setConvertedTurnOver(amount);
    }
  }, [data, amount, fromCurrency, toCurrency]);

  return {
    convertedTurnOver,
    isLoading,
    isError,
    error,
  };
};

export default useConvertedCurrency;
